import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import React, { PropsWithChildren, ReactElement } from 'react';

import classes from './FlowInfo.module.css';
import { IFlowInfoItemProps } from './FlowInfo.types';

const FlowInfoItem = ({ children, title }: PropsWithChildren<IFlowInfoItemProps>): ReactElement => {
  return (
    <Space className="wb-flexbox wb-flexColumn" direction="vertical">
      <Text className={classes.title} type="secondary">
        {title}
      </Text>
      {children}
    </Space>
  );
};

export default FlowInfoItem;
